import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import withSizes from 'react-sizes';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import CarouselContainer from 'components/Carousel/CarouselContainer';
import Carousel from 'components/ResourcesCarousel';
import ClientExclusiveCard from './ClientExclusiveCard';

const useStyles = makeStyles({
  padding: {
    paddingBottom: '60px !important ',
  },
});

function ClientExclusive({ data, grayscale, isMobile, isTablet, isBigTablet }) {
  const classes = useStyles();
  const clientDetails = useSelector(makeSelectClientDetails());
  const responsive = {
    desktop: {
      breakpoint: {
        max: 4000,
        min: 960,
      },
      items: 4,
    },
    bigTablet: {
      breakpoint: {
        max: 960,
        min: 768,
      },
      items: 3,
    },
    tablet: {
      breakpoint: {
        max: 768,
        min: 480,
      },
      items: 2,
    },
    mobile: {
      breakpoint: {
        max: 480,
        min: 0,
      },
      items: 1,
    },
  };
  const slidesToSlide = isMobile ? 1 : isTablet ? 2 : isBigTablet ? 3 : 4;
  if (_isEmpty(data)) return null;

  return (
    <CarouselContainer otherClasses={classes.padding}>
      <Carousel
        responsive={responsive}
        infinite={!!isMobile}
        slidesToSlide={slidesToSlide}
        small={
          isMobile && _get(clientDetails, 'metadata.displayNewLinkCard', false)
        }
      >
        {data
          .filter(item => _get(item, 'reviewStatus') === 'Accepted')
          .map(item => (
            <ClientExclusiveCard
              item={item}
              key={item.slug}
              page="Home"
              grayscale={grayscale}
            />
          ))}
      </Carousel>
    </CarouselContainer>
  );
}

ClientExclusive.propTypes = {
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool,
  grayscale: PropTypes.bool,
  data: PropTypes.array,
};

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
  isTablet: width <= 768,
  isBigTablet: width <= 960,
});
export default withSizes(mapSizesToProps)(ClientExclusive);
